import { listenDOMEvent } from '@jspartials/dom-api-utils';

const SHOW_FPS = false;
const NUMBER_OF_PARTICLES = 200;
const canvas = document.getElementById('confetti');
const ctx = canvas.getContext('2d');
// Init canvas sizes
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;
// Set up an OffscreenCanvas
const offscreenCanvas = new OffscreenCanvas(canvas.width, canvas.height);
const offscreenContext = offscreenCanvas.getContext('2d');

const svgPath2 = globalVariables.image.confetti_3;
const svgPath3 = globalVariables.image.confetti_5;
const svgPath4 = globalVariables.image.anto;

// random bright colors
const colors = [
  '#10b981',
  '#7c3aed',
  '#fbbf24',
  '#ef4444',
  '#3b82f6',
  '#22c55e',
  '#f97316',
  '#ef4444'
];

var buttonElement = document.querySelector('.js-button-confetti') || null;
var confettiElement = buttonElement
  ? buttonElement.querySelector('.hw-confirmation__confetti-icon')
  : HTMLElement;
var firstTime = true;
var fpsHistory = [];
var lastFrameTime = performance.now(); // Time of the last frame
var fps = 0; // Current FPS
var cannon = null;

class Particle {
  constructor(x, y, size, spreadX, spreadY) {
    this.x = x;
    this.y = y;
    this.size = size;
    this.speedX = Math.random() * (15 - -15) - 15 + spreadX; // Max 15, min -15
    this.speedY = Math.random() * (15 - -18) - 18 + spreadY; // Max 15, min -18
    this.spreadY = spreadY;
    this.gravity = 0.98;
    this.color = colors[Math.floor(Math.random() * colors.length)];
  }

  update() {
    this.x += this.speedX;
    this.y += this.speedY;

    if (this.speedX > 0) {
      this.speedX += 1 / 1000;
    } else {
      this.speedX -= 1 / 1000;
    }
    this.speedY *= this.gravity;
    this.speedY += 1 / 5;
  }
}

class Rectangle extends Particle {
  constructor(x, y, size, spreadX, spreadY) {
    super(x, y, size, spreadX, spreadY);
  }

  draw() {
    offscreenContext.save();
    offscreenContext.translate(this.x, this.y);
    offscreenContext.rotate(0.46 + this.speedY + this.spreadY);
    offscreenContext.fillStyle = this.color;
    offscreenContext.fillRect(
      -this.size / 2,
      -this.size / 4,
      this.size,
      this.size / 2
    );
    offscreenContext.restore();
  }
}

class Sunglasses extends Particle {
  constructor(x, y, size, spreadX, spreadY) {
    super(x, y, size, spreadX, spreadY);
    const img = new Image();
    img.src =
      this.size === 30 ? svgPath4 : this.size > 30 ? svgPath3 : svgPath2;
    this.img = img;
  }

  draw() {
    offscreenContext.save();
    offscreenContext.translate(this.x, this.y);
    offscreenContext.rotate(0.46 + this.speedY + this.spreadY);
    offscreenContext.drawImage(
      this.img,
      -this.size / 2,
      -this.size / 2,
      this.size,
      this.size
    );
    offscreenContext.restore();
  }
}

class Cannon {
  constructor(x, y) {
    this.x = x;
    this.y = y;
    this.particles = [];
    this.speedX = 0;
    this.speedY = 0;
    this.numberOfParticles = 0;
    offscreenContext.save();
    offscreenContext.translate(x, y);
  }
}

function setUpCannon(particles, numberOfParticles) {
  if (particles.length > numberOfParticles) {
    particles.length = numberOfParticles;
  } else if (particles.length < numberOfParticles) {
    for (let index = particles.length; index < numberOfParticles; index++) {
      var spreadX = Math.random() * (4 - -4) + -4; // Max 4, min -4
      var spreadY = Math.random() * (4 - -4) + -4; // Max 4, min -4
      var sizeRandom = Math.random() * (5 - -5) + -5; // Max 5, min -5
      if ((index + 1) % (NUMBER_OF_PARTICLES * 8) === 0) {
        // 1/8 of the time, add a face
        particles.push(
          new Sunglasses(cannon.x, cannon.y, 30, spreadX, spreadY)
        );
      } else if (index % 20 === 0) {
        particles.push(
          new Sunglasses(cannon.x, cannon.y, 30 + sizeRandom, spreadX, spreadY)
        );
      } else {
        particles.push(
          new Rectangle(cannon.x, cannon.y, 10 + sizeRandom, spreadX, spreadY)
        );
      }
    }
  }
}

function init() {
  offscreenContext.setTransform(1, 0, 0, 1, 0, 0);
  offscreenContext.clearRect(0, 0, canvas.width, canvas.height);
  cannon = new Cannon(
    buttonElement.getBoundingClientRect().x + buttonElement.offsetWidth / 2,
    buttonElement.getBoundingClientRect().y + buttonElement.offsetHeight / 2
  );
}

function shotConfetti() {
  cannon.numberOfParticles = cannon.particles.length;
  cannon.numberOfParticles += NUMBER_OF_PARTICLES; // Add 250 particles
  setUpCannon(cannon.particles, cannon.numberOfParticles);
  if (firstTime) {
    window.requestAnimationFrame(draw);
    firstTime = false;
    confettiElement.classList.remove('hw-confirmation__confetti-icon');
  }
}

function addFpsMeter() {
  const now = performance.now();
  const deltaTime = (now - lastFrameTime) / 1000;
  lastFrameTime = now;

  const currentFPS = 1 / deltaTime;
  fpsHistory.push(currentFPS);

  if (fpsHistory.length > 60) {
    // Average FPS over the last 60 frames
    fpsHistory.shift();
  }

  fps = fpsHistory.reduce((a, b) => a + b, 0) / fpsHistory.length;

  // Display FPS on the canvas
  offscreenContext.fillStyle = 'black';
  offscreenContext.font = '16px Arial';
  offscreenContext.fillText(`FPS: ${Math.round(fps)}`, 10, 110);
}

function draw() {
  offscreenContext.setTransform(1, 0, 0, 1, 0, 0);

  // Clear the offscreen canvas
  offscreenContext.clearRect(0, 0, canvas.width, canvas.height);

  if (SHOW_FPS) addFpsMeter();

  for (var i = 0; i < cannon.particles.length; i++) {
    var particle = cannon.particles[i];

    if (particle.y < canvas.height + 200) {
      particle.draw();
      particle.update();
    }
  }

  // Clear the main canvas and draw the offscreen canvas onto it
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(offscreenCanvas, 0, 0);

  window.requestAnimationFrame(draw);
}

if (buttonElement) {
  listenDOMEvent(document, 'DOMContentLoaded', init);

  listenDOMEvent(buttonElement, 'click', shotConfetti);
  // add resize handler
  listenDOMEvent(window, 'resize', () => {
    canvas.height = window.innerHeight;
    canvas.width = window.innerWidth;
    offscreenCanvas.width = canvas.width;
    offscreenCanvas.height = canvas.height;
    cannon.x =
      buttonElement.getBoundingClientRect().x + buttonElement.offsetWidth / 2;
    cannon.y =
      buttonElement.getBoundingClientRect().y + buttonElement.offsetHeight / 2;
  });
}
